var exports = {
  "k": "x127c5a35--a99000--container",
  "K": "x127c5a35--a99000--icon",
};

module.exports = exports;
